import { useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/App";
import { LogOut, MoreVertical, Settings, User } from "lucide-react";

const UserMenu = ({ userName, showSettings = false, onSettings, settingsLabel = "Paramètres" }) => {
  const [isOpen, setIsOpen] = useState(false);
  const menuRef = useRef(null);
  const { logout } = useAuth();
  const navigate = useNavigate();

  // Close menu when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleLogout = async () => {
    setIsOpen(false);
    await logout();
    navigate("/");
  };

  return (
    <div className="relative" ref={menuRef}>
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center gap-2 px-3 py-2 rounded-lg hover:bg-[#2A3A4D] transition-colors"
        data-testid="user-menu-btn"
      >
        {userName && (
          <span className="text-[#94A3B8] hidden sm:inline">
            {userName}
          </span>
        )}
        <MoreVertical className="w-5 h-5 text-[#94A3B8]" />
      </button>

      {isOpen && (
        <div className="absolute right-0 top-full mt-2 w-48 bg-[#1F2A38] border border-[#2A3A4D] rounded-xl shadow-xl z-50 overflow-hidden">
          {userName && (
            <div className="px-4 py-3 border-b border-[#2A3A4D]">
              <p className="text-sm font-medium text-white truncate">{userName}</p>
            </div>
          )}
          
          {showSettings && onSettings && (
            <button
              onClick={() => {
                setIsOpen(false);
                onSettings();
              }}
              className="w-full flex items-center gap-3 px-4 py-3 text-[#94A3B8] hover:bg-[#2A3A4D] hover:text-white transition-colors"
              data-testid="settings-menu-item"
            >
              <Settings className="w-4 h-4" />
              {settingsLabel}
            </button>
          )}
          
          <button
            onClick={handleLogout}
            className="w-full flex items-center gap-3 px-4 py-3 text-red-400 hover:bg-red-500/10 transition-colors"
            data-testid="logout-menu-item"
          >
            <LogOut className="w-4 h-4" />
            Déconnexion
          </button>
        </div>
      )}
    </div>
  );
};

export default UserMenu;
